var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TabsBuilder',{attrs:{"isDarkMode":_vm.isDarkMode,"navigationDescription":_vm.componentData.description}},_vm._l((_vm.divisions),function(division,index){return _c('li',{key:index,staticClass:"owc-division-switcher__item",class:{
      'owc-division-switcher__item--active': division.isActive,
      'owc-division-switcher__item--dark': _vm.isDarkMode,
    },attrs:{"slot":"tab-bar"},slot:"tab-bar"},[_c('a',{staticClass:"wb-button wb-button--tertiary wb-button--medium",class:{
        'wb-button--theme-dark': _vm.isDarkMode,
      },attrs:{"aria-current":division.isActive ? 'page' : false,"href":division.link.url,"target":division.link.target}},[_vm._v(_vm._s(division.link.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }